import React from 'react';
import { useSelector } from 'react-redux';
import BottomSheet, {
  NAVIGATION,
  BUTTON_GROUP,
} from '@nykaa/nes-ui-components/BottomSheet';
import { LoadingScreen } from '@nykaa/nes-auth-shared';
import { BOTTOMSHEET_OVERRIDES } from '@nykaa/nes-auth/constants';
import { AuthBottomSheetProps } from '@nykaa/nes-auth/types';
import Header from '@nykaa/nes-auth/components/Header';
import Widgets from 'components/Widgets';
import styled from 'App/styled';
import { screenType } from '@nykaa/nes-auth-shared/store/constants';
import { State } from 'store/types';

const WidgetWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.spacing80};
`;

const AuthBottomSheet = ({
  children,
  isLoading,
  isNudge,
  handleNavigation,
  navigation = NAVIGATION.none,
  showOverlay,
  title,
  subTitle,
  banner,
  height,
  bannerWidgets = [],
  signupBannerAdplatformEnabled,
}: AuthBottomSheetProps) => {
  const overrides = { ...BOTTOMSHEET_OVERRIDES };
  if (isNudge || showOverlay) overrides.Overlay.style.display = 'block';
  if (height) overrides.Root.style.height = height;
  const isFetching = useSelector((state: State) => state.auth.fetching);
  return (
    <BottomSheet
      buttonGroup={BUTTON_GROUP.none}
      navigation={navigation}
      overrides={overrides}
      handleNavigationClick={handleNavigation}
    >
      {(isLoading || isFetching) && <LoadingScreen isBottomSheet />}
      <Header
        title={title}
        subTitle={subTitle}
        banner={banner}
        signupBannerAdplatformEnabled={signupBannerAdplatformEnabled}
        bannerWidgets={bannerWidgets}
      >
        {signupBannerAdplatformEnabled && (
          <WidgetWrapper>
            <Widgets
              widgets={bannerWidgets}
              pageName={screenType.MWEB_SIGNUP_PROMPT}
            />
          </WidgetWrapper>
        )}
      </Header>
      {children}
    </BottomSheet>
  );
};

export default AuthBottomSheet;
